// extracted by mini-css-extract-plugin
export default {"delPenSvgIcon":"style_delPenSvgIcon__GZL6u","Toggle":"style_Toggle__6kGTM"};